import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import styled from "@emotion/styled";
import { useMemo } from "react";

interface SwitchItem extends I_GENERIC_ITEMS {
  label: string;
  value: any;
}

export interface MxRushSwitchFieldProps {
  items: SwitchItem[];
  name: string;
  testId?: string;
  value: SwitchItem[];
  id: string;
  onChange?: (event: {
    target: {
      value: SwitchItem[];
      name: string;
      id: string | number;
    };
  }) => void;
  onBlur?: () => void;
  error?: boolean;
  disabled?: boolean;
}

function MxRushSwitchField({
  name,
  items,
  value,
  id,
  error = false,
  disabled = false,
  onChange,
  onBlur
}: MxRushSwitchFieldProps) {
  const handleChange = (item: SwitchItem) => {
    onChange?.({
      target: {
        id,
        name,
        value: [item]
      }
    });
    onBlur?.();
  };

  const selectedValue = useMemo(() => value?.[0]?.value ?? null, [value]);

  return (
    <Content
      error={error}
      disabled={disabled}
      data-testid={`${id}-rush-switch-field`}
    >
      <AnimatedView activeFirst={selectedValue === items[0]?.value} />
      {items.map(item => (
        <ItemOption
          key={item.value}
          onClick={() => !disabled && handleChange(item)}
          isActive={selectedValue === item.value}
          disabled={disabled}
          data-testid={`${id}-rush-switch-field-item-${item.value}`}
        >
          <TextOption isActive={selectedValue === item.value}>
            {item.label}
          </TextOption>
        </ItemOption>
      ))}
    </Content>
  );
}

export default MxRushSwitchField;

const height = 30;
const Content = styled.div<{ error: boolean; disabled: boolean }>`
  border: ${({ error }) => (error ? "1px solid var(--color-error)" : "none")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "default")};
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: ${height}px;
  position: relative;
  background-color: var(--m-color-gray-02);
  border-radius: 50px;
`;

const AnimatedView = styled.div<{ activeFirst: boolean }>`
  position: absolute;
  border-radius: 50px;
  height: ${height}px;
  width: 54%;
  background-color: var(--color-blue-main);
  z-index: 0;
  transform: ${({ activeFirst }) =>
    activeFirst ? "translateX(0)" : "translateX(85%)"};
  transition: transform 0.2s;
`;

const ItemOption = styled.div<{ isActive: boolean; disabled: boolean }>`
  height: ${height}px;
  display: flex;
  border-radius: 45px;
  justify-content: center;
  align-items: center;
  width: 50%;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

const TextOption = styled.span<{ isActive: boolean }>`
  font-size: var(--fs-text-small);
  font-weight: bold;
  width: 50%;
  text-align: center;
  color: ${({ isActive }) => (isActive ? "#FFF" : "#fff")};
  position: ${({ isActive }) => (isActive ? "absolute" : "relative")};
  z-index: 1;
  transition: color 0.2s;
`;
